import React from 'react';
import { ActivityIcon as Activity, AlertTriangleIcon as AlertTriangle, CheckCircle2Icon as CheckCircle2, XIcon as X, WifiIcon as Wifi, WifiOffIcon as WifiOff, TestTubeIcon as TestTube } from '../../icons';

interface MonitorStatusPanelProps {
  isMonitorando: boolean;
  webViewInicializado: boolean;
  estatisticas: {
    handlers: {
      alterado: number;
      removido: number;
      criado: number;
      total: number;
    };
  };
  referenciasAtivas?: number;
  onClose: () => void;
  onTestarComunicacao?: () => void;
  onNotificarWebView?: () => void;
}

export function MonitorStatusPanel({ 
  isMonitorando, 
  webViewInicializado, 
  estatisticas, 
  referenciasAtivas = 0,
  onClose,
  onTestarComunicacao,
  onNotificarWebView
}: MonitorStatusPanelProps) {
  return (
    <div className="absolute top-0 left-0 right-0 bg-navy-800 border-b border-navy-700 z-50">
      <div className="flex justify-between items-center p-3 border-b border-navy-700">
        <div className="flex items-center space-x-2">
          {isMonitorando ? (
            <Activity className="w-4 h-4 text-green-500 animate-pulse" />
          ) : (
            <AlertTriangle className="w-4 h-4 text-yellow-500" />
          )}
          <span className="text-sm font-medium text-white">
            Monitor de Objetos
          </span>
        </div>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-white transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      <div className="p-3">
        <div className="grid grid-cols-2 gap-3 text-xs">
          {/* Status WebView2 */}
          <div className="flex items-center space-x-2">
            {webViewInicializado ? (
              <Wifi className="w-3 h-3 text-green-500" />
            ) : (
              <WifiOff className="w-3 h-3 text-red-500" />
            )}
            <span className="text-gray-300">WebView2:</span>
            <span className={`px-1.5 py-0.5 rounded text-xs font-medium ${
              webViewInicializado 
                ? 'bg-green-900 text-green-300' 
                : 'bg-red-900 text-red-300'
            }`}>
              {webViewInicializado ? 'OK' : 'ERRO'}
            </span>
          </div>

          {/* Status Monitoramento */}
          <div className="flex items-center space-x-2">
            {isMonitorando ? (
              <Activity className="w-3 h-3 text-green-500 animate-pulse" />
            ) : (
              <AlertTriangle className="w-3 h-3 text-yellow-500" />
            )}
            <span className="text-gray-300">Monitor:</span>
            <span className={`px-1.5 py-0.5 rounded text-xs font-medium ${
              isMonitorando 
                ? 'bg-green-900 text-green-300' 
                : 'bg-yellow-900 text-yellow-300'
            }`}>
              {isMonitorando ? 'ON' : 'OFF'}
            </span>
          </div>
        </div>

        {/* Estatísticas em linha única */}
        <div className="flex items-center justify-between mt-3 text-xs text-gray-400">
          <div className="flex items-center space-x-3">
            <span>Alt: {estatisticas.handlers.alterado}</span>
            <span>Cri: {estatisticas.handlers.criado}</span>
            <span>Rem: {estatisticas.handlers.removido}</span>
          </div>
          <div className="flex items-center space-x-3">
            <span className="text-white font-medium">Total: {estatisticas.handlers.total}</span>
            <span className="text-blue-400">Ref: {referenciasAtivas}</span>
          </div>
        </div>

        {/* Aviso WebView2 - apenas se necessário */}
        {!webViewInicializado && (
          <div className="flex items-center justify-between mt-3 p-2 bg-red-900/20 border border-red-800 rounded">
            <span className="text-red-400 font-medium text-xs">
              ⚠️ WebView2 não inicializado
            </span>
            <div className="flex items-center space-x-1">
              {onNotificarWebView && (
                <button
                  onClick={onNotificarWebView}
                  className="px-2 py-1 bg-blue-600 hover:bg-blue-700 text-white text-xs rounded"
                  title="Notificar WebView2"
                >
                  <Wifi className="w-3 h-3" />
                </button>
              )}
              {onTestarComunicacao && (
                <button
                  onClick={onTestarComunicacao}
                  className="px-2 py-1 bg-green-600 hover:bg-green-700 text-white text-xs rounded"
                  title="Testar Comunicação"
                >
                  <TestTube className="w-3 h-3" />
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}